import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    AllProductsModule,
    CartModule,
    CategoriesModule,
    ForgotPasswordModule,
    LandingModule,
    ProductsModule,
    ResetPasswordComponent,
    ResetPasswordModule,
    SearchModule,
} from './containers';
import { EditMyProfileModule, OrderSuccessModule, PaymentModule, ProductDetailsMobileModule, ProductModule, PublicProfileModule, ReviewFormMobileModule } from './components';
import { BrandListModule } from './components/brand-list/brand-list.module';
import { ProductCollectionsComponent } from './containers/product-collections/product-collections.component';
import { CollectionListModule } from './components/collection-list/collection-list.module';
import { OfferDailogComponent } from './components/offer-dailog/offer-dailog.component';
import { NewsletterPopupComponent } from './components/newsletter-popup/newsletter-popup.component';
import {
    CustomSnackBarComponent,
    WishlistLoginPromptModalComponent
} from './components/modals/wishlist-login-prompt-modal/wishlist-login-prompt-modal.component';
import { SharedModule } from '../shared/shared.module';
import { AdminDashboardComponent } from './components/admin-dashboard/admin-dashboard.component';
import { PrdAvailStatusDialogComponent } from './components/prd-avail-status-dialog/prd-avail-status-dialog.component';
import { QuizDialogComponent } from './containers/quiz-dialog/quiz-dialog.component';
import { ProductKeywordMappingModule } from './containers/product-keyword-mapping/product-keyword-mapping.module';
import { DesignDashboardComponent } from './containers/design-dashboard/design-dashboard.component'; 
import { BrandsComponent } from './components/brands/brands.component';
import { ViewFilesComponent } from './components/view-files/view-files.component';
import { NgxPaginationModule } from 'ngx-pagination'; 
import { AuthModule } from '../core/components/auth/auth.module';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { ViewProjectIntakeFormComponent } from './components/view-project-intake-form/view-project-intake-form.component';
import { ProductRestrictedComponent } from './components/product-restricted/product-restricted.component';
import { ProductRestrictedMobileComponent } from './components/product-details/product-restricted-mobile/product-restricted-mobile.component';
import { AllRoomsComponent } from './components/all-rooms/all-rooms.component';
import { CompareComponent } from './components/compare/compare.component';



import { DesignProposalsComponent } from './components/design-proposals/design-proposals.component';
import { ShoppingListComponent } from './components/shopping-list/shopping-list.component';
import { MaterialModule } from 'src/app/shared/material-module';
import { AddShoppingProductDialogComponent } from './components/add-shopping-product-dialog/add-shopping-product-dialog.component'; 
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DesignProposalsSummaryComponent } from './components/design-proposals-summary/design-proposals-summary.component';
import { NgxMasonryModule } from 'ngx-masonry';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FavoritesComponent } from './components/favorites/favorites.component';
import { PinterestBoardComponent } from './components/pinterest-board/pinterest-board.component';
import { ProductCatalogComponent } from './components/product-catalog/product-catalog.component';
import { ContactLogComponent } from './components/contact-log/contact-log.component';
import { DesignHistoryComponent } from './components/design-history/design-history.component';
import { DesignContactLogComponent } from './containers/design-contact-log/design-contact-log.component';
import { DesignNotesComponent } from './components/design-notes/design-notes.component';
import { DueDateDialogComponent } from './containers/due-date-dialog/due-date-dialog.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { RoomSpecsComponent } from './components/room-specs/room-specs.component';
import { AddPaintColorDialogComponent } from './components/room-specs/add-paint-color-dialog/add-paint-color-dialog.component';
import { CustomerFavoritesComponent } from './components/customer-favorites/customer-favorites.component';
const DECLARATIONS = [
    ResetPasswordComponent,
    ProductCollectionsComponent,
    OfferDailogComponent, 
];
const MODULES = [
    CommonModule,
    ProductsModule,
    ProductModule,
    LandingModule,
    SearchModule,
    AllProductsModule,
    CategoriesModule,
    ProductDetailsMobileModule,
    CartModule,
    PaymentModule,
    OrderSuccessModule,
    ForgotPasswordModule,
    ResetPasswordModule,
    EditMyProfileModule,
    BrandListModule,
    PublicProfileModule,
    CollectionListModule,
    SharedModule,
    NgxPaginationModule,
    // ReviewFormModule,
    ReviewFormMobileModule,
    ProductKeywordMappingModule,
    AuthModule,
    MaterialModule,
    InfiniteScrollModule,
    NgxMasonryModule, DragDropModule,
    NgxMatSelectSearchModule,
    FormsModule,
    ReactiveFormsModule
];

@NgModule({
    declarations: [
        ...DECLARATIONS,
        NewsletterPopupComponent,
        WishlistLoginPromptModalComponent,
        CustomSnackBarComponent,
        AdminDashboardComponent,
        PrdAvailStatusDialogComponent,
        QuizDialogComponent,
        DesignDashboardComponent,
        ProductCatalogComponent,
        BrandsComponent,
        ViewFilesComponent,
        ThankYouComponent,
        ViewProjectIntakeFormComponent,
        ProductRestrictedComponent,
        ProductRestrictedMobileComponent,
        AllRoomsComponent,
        DesignProposalsComponent, 
        ShoppingListComponent,
        AddShoppingProductDialogComponent,
        CompareComponent,
        DesignProposalsSummaryComponent,
        FavoritesComponent,
        PinterestBoardComponent,
        ProductCatalogComponent,
        ContactLogComponent,
        DesignHistoryComponent,
        DesignContactLogComponent,
        DesignNotesComponent,
        DueDateDialogComponent,
        RoomSpecsComponent, 
        AddPaintColorDialogComponent, CustomerFavoritesComponent,
    ],
    imports: [...MODULES],
    // providers: [AmericanNumberPipe],
    exports: [...DECLARATIONS, ...MODULES],
    entryComponents: [OfferDailogComponent, DueDateDialogComponent, NewsletterPopupComponent, WishlistLoginPromptModalComponent, CustomSnackBarComponent,PrdAvailStatusDialogComponent,QuizDialogComponent,AddPaintColorDialogComponent]
})
export class FeatureModule {
}
